import Banner from "../assets/images/Contact-us-Banner.png";
import MobileBanner from "../assets/images/ContactUs_Mobile.jpg";

const ContactUs = () => {
  return (
    <>
      <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
        {/* Banner Section - Starts from absolute top */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "800px",
            overflow: "hidden",
          }}
        >
          <img
            src={Banner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block",
            }}
            className="desktop-banner"
          />
          <img
            src={MobileBanner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "none",
            }}
            className="mobile-banner"
          />
          <style>{`
            @media (max-width: 768px) {
              .desktop-banner {
                display: none !important;
              }
              .mobile-banner {
                display: block !important;
              }
            }
          `}</style>
        </div>
      </div>
      <div className="min-vh-100" style={{ backgroundColor: "#e8e8e8" }}>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
          rel="stylesheet"
        />

        <div className="container py-5">
          {/* Header */}
          <div className="text-center pb-5 mb-5 position-relative">
            <h2
              className="fw-normal"
              style={{
                color: "#666",
                fontSize: "2rem",
                zIndex: 2,
                position: "relative",
              }}
            >
              Contact
            </h2>
            <div
              style={{
                position: "absolute",
                top: "-20px",
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "10rem",
                fontFamily: "'Brush Script MT', cursive",
                color: "rgba(255, 255, 255, 0.4)",
                fontWeight: "bold",
                zIndex: 1,
                whiteSpace: "nowrap",
              }}
            >
              Us
            </div>
          </div>

          {/* Content Row */}
          <div className="row g-4 mt-5">
            {/* Contact Information */}
            <div className="col-lg-5">
              <div className="pe-lg-4">
                {/* Address */}
                <div className="mb-5">
                  <h3
                    className="fw-bold mb-3"
                    style={{ color: "#777", fontSize: "1.8rem" }}
                  >
                    Address
                  </h3>
                  <a
                    href="https://maps.app.goo.gl/YKHTawRu72t635uH7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                    style={{
                      color: "#666",
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#8B7AB8")}
                    onMouseLeave={(e) => (e.target.style.color = "#666")}
                  >
                    Sparling Compound, Shyam Nagar, Aligarh (U.P), 202001, India
                  </a>
                </div>

                {/* Phone */}
                <div className="mb-5">
                  <h3
                    className="fw-bold mb-3"
                    style={{ color: "#777", fontSize: "1.8rem" }}
                  >
                    Phone
                  </h3>
                  <a href="tel:+91-8077147169" className="text-muted mb-0" style={{ fontSize: "1.1rem" }}>
                    +91-8077147169
                  </a>
                </div>

                {/* Email */}
                <div className="mb-5">
                  <h3
                    className="fw-bold mb-3"
                    style={{ color: "#777", fontSize: "1.8rem" }}
                  >
                    Email
                  </h3>
                  <a href="mailto:info@pupntreats.com" className="text-muted mb-0" style={{ fontSize: "1.1rem" }}>
                    info@pupntreats.com
                  </a>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="col-lg-7">
              <div
                className="bg-white position-relative"
                style={{
                  borderRadius: "30px",
                  overflow: "hidden",
                  height: "500px",
                  border: "1px solid #ddd",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center h-100"
                  style={{ backgroundColor: "#EBEBEB" }}
                >
                  <h2
                    className="fw-bold"
                    style={{ color: "#999", fontSize: "4rem" }}
                  >
                    Map
                  </h2>
                </div>

                {/* Embedded Google Map */}
                {/* <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3543.4285456789!2d78.0677!3d27.8974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDUzJzUwLjYiTiA3OMKwMDQnMDMuNyJF!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0, position: "absolute", top: 0, left: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Location Map"
                ></iframe> */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3528.7922150762784!2d78.07587423031113!3d27.889440682202004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3974a5765e92b57b%3A0x89b90da483f80088!2sPup%20n%20Treats%20-%20Himalayan%20chews%20for%20dogs!5e0!3m2!1sen!2sus!4v1760324115804!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0, position: "absolute", top: 0, left: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Pup n Treats Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
        
        body {
          font-family: 'Poppins', sans-serif;
        }
        
        h2, h3 {
          font-family: 'Poppins', sans-serif;
        }
        
        iframe {
          filter: grayscale(0%);
          transition: filter 0.3s ease;
        }
        
        iframe:hover {
          filter: grayscale(0%);
        }
      `}</style>
      </div>
    </>
  );
};

export default ContactUs;
